import { useCallback } from "react";
import { HandCoins } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import withRoleCheck from "components/hocs/withRoleCheck";
import RevenueOpportunityRecipientPresetService from "services/RevenueOpportunityRecipientPreset";
import {
  invalidateRevenueOpportunityRecipientPresetsTableQuery,
  useRevenueOpportunityRecipientPresetsTable,
} from "hooks/useRevenueOpportunityRecipientPresetsTable";
import RevenueOpportunityRecipientPresetModal from "routes/revenue_opportunity_recipient_presets/components/RevenueOpportunityRecipientPresetModal";

export const REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS = {
  tableName: "revenue_opportunity_recipient_presets",
  queryKey: "revenue_opportunity_recipient_preset",
  className: "RevenueOpportunityRecipientPreset",
  header: "Recipient Presets",
  headerIcon: HandCoins,
};

const NewRevenueOpportunityRecipientPresetModal = withRoleCheck(
  RevenueOpportunityRecipientPresetModal,
  [
    ACL_RELATIONSHIPS.revenueOpportunityRecipientPreset.create,
    ACL_RELATIONSHIPS.recipient.read,
  ]
);

const RevenueOpportunityRecipientPresetsTableV3 = () => {
  const { filters, columns } = useRevenueOpportunityRecipientPresetsTable({
    tableName: REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS.tableName,
  });

  const fetchPresets = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await RevenueOpportunityRecipientPresetService.getRevenueOpportunityRecipientPresetsAsTable(
            nextQueryParams
          );

        return response;
      } catch (error) {
        console.error(
          "Error fetching revenue opportunity recipient presets:",
          error
        );
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={
        REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS.headerIcon
      }
      header={REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS.header}
      tableName={
        REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS.tableName
      }
      queryKey={REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS.queryKey}
      className={
        REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS.className
      }
      fetchData={fetchPresets}
      createButton={
        <NewRevenueOpportunityRecipientPresetModal
          onSuccess={invalidateRevenueOpportunityRecipientPresetsTableQuery}
        />
      }
      enableSearch
      enableSettings
      invalidateData={invalidateRevenueOpportunityRecipientPresetsTableQuery}
    />
  );
};

export default RevenueOpportunityRecipientPresetsTableV3;
